// Claves de texto de Contactos: las que pide Contactos.razor del portal actual (ContactText, ContactC2Text,
// ContactE1Text y ContactC1DesignText), en el mismo orden. Generado; no editar a mano.
export const contactTextKeys: string[] = [
  "C1_BHELI_EXPORT",
  "C1_AI_AGENT",
  "C1_CLEAR_SELECTION",
  "C1_MATCH_WARNING",
  "C1_CREATE_DISTINCT",
  "C1_TITLE",
  "C1_R2_TAGS_ALSO",
  "C1_EMPTY_TITLE",
  "C1_DAY_ONE",
  "C1_DAYS_MANY",
  "C1_PAGE_EXPIRED",
  "C1_SESSION_ENDED",
  "C1_SIGN_IN",
  "C1_COPY_UNAVAILABLE",
  "C1_CONVERSATIONS",
  "C1_NEW",
  "C1_EDIT",
  "C1_IMPORT",
  "C1_EXPORT",
  "C1_COPY",
  "C1_COPY_PAGE",
  "C1_COPY_SELECTED",
  "C1_COPIED",
  "C1_COPY_BUSY",
  "C1_COPY_FAILED",
  "C1_COPY_MANUAL",
  "C1_COPY_FALLBACK",
  "C1_COLUMNS",
  "C1_MORE_CHANNEL",
  "C1_RESET_VIEW",
  "C1_SEARCH",
  "C1_FILTERS",
  "C1_TAGS",
  "C1_ALL_TAGS",
  "C1_ANY_TAGS",
  "C1_ALL",
  "C1_CLEAR",
  "C1_APPLY",
  "C1_CANCEL",
  "C1_CLOSE",
  "C1_SAVE",
  "C1_BACK",
  "C1_SEARCH_VIEWS",
  "C1_NEXT",
  "C1_PREVIOUS",
  "C1_LOADING",
  "C1_SAVING",
  "C1_RETRY",
  "C1_EMPTY",
  "C1_NO_RESULTS",
  "C1_COUNT",
  "C1_SELECTED",
  "C1_SELECT_PAGE",
  "C1_SELECT_CONTACT",
  "C1_PAGE",
  "C1_PAGE_SIZE",
  "C1_ORDER",
  "C1_SORT_CONVERSATION",
  "C1_SORT_CREATED",
  "C1_SORT_NAME",
  "C1_DATE_FIELD",
  "C1_CREATION",
  "C1_LAST_CONVERSATION",
  "C1_PERIOD",
  "C1_ANY_DATE",
  "C1_TODAY",
  "C1_7D",
  "C1_RANGE",
  "C1_FROM",
  "C1_TO",
  "C1_INVALID_RANGE",
  "C1_OPEN_CHAT",
  "C1_NO_SESSION",
  "C1_SESSIONS",
  "C1_SESSION",
  "C1_CHANNEL_DATA",
  "C1_UNASSIGNED",
  "C1_UNAVAILABLE",
  "C1_DENIED",
  "C1_MISSING",
  "C1_STALE",
  "C1_KEY_CONFLICT",
  "C1_INVALID",
  "C1_NAME_HELP",
  "C1_NAME_ERROR",
  "C1_PHONE_HELP",
  "C1_PHONE_ERROR",
  "C1_EMAIL_ERROR",
  "C1_TAGS_HELP",
  "C1_TAGS_ERROR",
  "C1_VERIFIED",
  "C1_SECONDARY",
  "C1_NONE",
  "C1_CURRENT",
  "C1_EXTRACT_SCOPE",
  "C1_SELECTED_SCOPE",
  "C1_PAGE_SCOPE",
  "C1_ALL_SCOPE",
  "C1_EXPORT_SUMMARY",
  "C1_EXPORT_SUMMARY_ONE",
  "C1_EXPORT_SUMMARY_FILTERED",
  "C1_EXPORT_SUMMARY_FILTERED_ONE",
  "C1_FORMAT",
  "C1_DOWNLOAD",
  "C1_ALL_FIELDS",
  "C1_FILE",
  "C1_MAPPING",
  "C1_PREVIEW",
  "C1_RESULT",
  "C1_FILE_HELP",
  "C1_TEMPLATE",
  "C1_SEPARATOR",
  "C1_COMMA",
  "C1_SEMICOLON",
  "C1_TAB",
  "C1_SOURCE",
  "C1_EXAMPLE",
  "C1_OMIT",
  "C1_MAPPING_ERROR",
  "C1_READY",
  "C1_EXISTS",
  "C1_INVALID_ROW",
  "C1_ROW",
  "C1_PENDING_ONLY",
  "C1_REVIEW_FIELD",
  "C1_ADD_COUNT",
  "C1_CONFIRM_IMPORT",
  "C1_ADDED",
  "C1_PENDING",
  "C1_REPORT",
  "C1_UPLOAD_ANOTHER",
  "C1_VIEW_CONTACTS",
  "C1_IMPORT_FORMAT",
  "C1_IMPORT_LIMIT",
  "C1_IMPORT_EXPIRED",
  "C1_EXPORT_LIMIT",
  "C1_DIRECTORY_LIMIT",
  "C1_EXISTING_CONTACT",
  "C1_DUPLICATE_FILE",
  "C1_PROCESS_ERROR",
  "C1_TENANT_CHANGED",
  "C1_RELOAD",
  "C1_PROSPECT",
  "C1_CUSTOMER",
  "C1_PARTNER",
  "C1_OTHER",
  "C1_UNSAVED",
  "C1_FIELD_CONTACT",
  "C1_FIELD_FIRSTNAME",
  "C1_FIELD_LASTNAME",
  "C1_FIELD_EMAIL",
  "C1_FIELD_PHONE",
  "C1_FIELD_TAGS",
  "C1_FIELD_RELATIONSHIPSTATUS",
  "C1_FIELD_CREATEDAT",
  "C1_FIELD_UPDATEDAT",
  "C1_FIELD_ID",
  "C1_FIELD_ROWVERSION",
  "C1_FIELD_EMAILVERIFIED",
  "C1_FIELD_PHONEVERIFIED",
  "C1_FIELD_LASTVISIBLECONVERSATIONACTIVITYAT",
  "C1_FIELD_AGENT",
  "C1_FIELD_INBOX",
  "C1_FIELD_CHANNEL",
  "C1_FIELD_CHANNELDISPLAYNAME",
  "C1_FIELD_EXTERNALIDENTITYTYPE",
  "C1_FIELD_EXTERNALIDENTITYVALUE",
  "C1_FIELD_PLATFORM",
  "C2_FILE_OPTIONS",
  "C2_BHELI_FILE",
  "C2_BHELI_FILE_HELP",
  "C2_TEMPLATE_EXCEL",
  "C2_SEPARATOR_AUTO",
  "C2_DELIMITER_AMBIGUOUS",
  "C2_IMPORT_SEPARATOR",
  "C2_ADDED_ONE",
  "C2_ADDED_MANY",
  "C2_ADD_ONE",
  "C2_ADD_MANY",
  "C2_CHOOSE_FILE",
  "C2_TAGS_MORE",
  "C2_SEARCH_TAGS",
  "C2_SEARCH_AGENTS",
  "C2_ANY_TAG_HELP",
  "C2_ALL_TAG_HELP",
  "C2_TAG_SEARCH_MORE",
  "C2_TAG_LIMIT",
  "C2_SCOPE_UPDATED",
  "C2_SCOPE_RETRY",
  "C2_TOTAL_ONE",
  "C2_TOTAL",
  "C2_RANGE",
  "C2_BACK",
  "C2_ASSIGNED_ONE",
  "C2_ASSIGNED",
  "C2_SKIPPED_ONE",
  "C2_SKIPPED",
  "C2_WARNING_ONE",
  "C2_WARNING",
  "C2_VIEW_DETAIL",
  "C2_VIEW_ALL",
  "C2_ALL_FILTER",
  "C2_STATE",
  "C2_STEP_OF",
  "C2_VIEW_AGENTS",
  "C2_FILE_COLUMNS_ONE",
  "C2_FILE_COLUMNS",
  "C2_TAG_ROWS_ONE",
  "C2_TAG_ROWS",
  "C2_IN_FILE",
  "C2_FIELD_IN_BHELI",
  "C2_OMITTED",
  "C2_SHORT_PAGE",
  "C2_SEARCH_FIELDS",
  "C2_RESULT_PENDING_ONE",
  "C2_RESULT_PENDING",
  "C2_REASON",
  "C2_REASON_FIRSTNAME",
  "C2_REASON_LASTNAME",
  "C2_REASON_EMAIL",
  "C2_REASON_PHONE",
  "C2_REASON_RELATIONSHIPSTATUS",
  "C2_REASON_TAGS",
  "E1_TITLE",
  "E1_SHARED",
  "E1_NEW",
  "E1_SEARCH",
  "E1_NAME",
  "E1_COLOR",
  "E1_DESCRIPTION",
  "E1_CONTACTS",
  "E1_CREATED",
  "E1_STATE",
  "E1_ACTIVE",
  "E1_ARCHIVED",
  "E1_ALL",
  "E1_SORT",
  "E1_SORT_CREATED",
  "E1_SORT_NAME",
  "E1_SORT_USED",
  "E1_FILTERS",
  "E1_FROM",
  "E1_TO",
  "E1_CLEAR",
  "E1_APPLY",
  "E1_SAVE",
  "E1_CANCEL",
  "E1_CLOSE",
  "E1_EDIT",
  "E1_ARCHIVE",
  "E1_RESTORE",
  "E1_ARCHIVE_CONFIRM",
  "E1_RESTORE_CONFIRM",
  "E1_SELECT_PAGE",
  "E1_SELECTED",
  "E1_CLEAR_SELECTION",
  "E1_COPY",
  "E1_COPIED",
  "E1_COPY_FALLBACK",
  "E1_EXPORT",
  "E1_EXPORT_TAGS",
  "E1_EXPORT_CONTACTS",
  "E1_FILTERED_SCOPE",
  "E1_SELECTED_SCOPE",
  "E1_DOWNLOAD",
  "E1_PAGE_SIZE",
  "E1_PREVIOUS",
  "E1_NEXT",
  "E1_PAGE",
  "E1_COUNT",
  "E1_EMPTY",
  "E1_NO_RESULTS",
  "E1_LOADING",
  "E1_UNAVAILABLE",
  "E1_DENIED",
  "E1_STALE",
  "E1_INVALID",
  "E1_NAME_REQUIRED",
  "E1_TAG_DUPLICATE",
  "E1_TAG_DUPLICATE_ARCHIVED",
  "E1_TAG_ARCHIVED",
  "E1_TAG_NOT_FOUND",
  "E1_RANGE_ERROR",
  "E1_UNSAVED",
  "E1_MANAGE",
  "E1_ASSIGN",
  "E1_ASSIGN_SEARCH",
  "E1_ASSIGN_HELP",
  "E1_TAG_LIMIT",
  "E1_MORE",
  "E1_SETTINGS",
  "E1_ROLES",
  "E1_BACK_TAGS",
  "E1_SAVED",
  "E1_BULK_RESULT",
  "E1_NONE",
  "E1_CONTACTS_UNAVAILABLE",
  "E1_NAME_HELP",
  "E1_DESCRIPTION_HELP",
  "E1_EXCEL",
  "E1_MANUAL_COPY_HELP",
  "E1_SELECT_ALL",
  "E1_DONE",
  "E1_CUSTOM_COLOR",
  "E1_PREVIEW_TAG",
  "E1_COLOR_RUST",
  "E1_COLOR_GREEN",
  "E1_COLOR_PURPLE",
  "E1_COLOR_BLUE",
  "E1_COLOR_TURQUOISE",
  "E1_COLOR_PINK",
  "E1_COLOR_OLIVE",
  "E1_COLOR_RED",
  "E1_COLOR_ORANGE",
  "E1_COLOR_YELLOW",
  "E1_COLOR_BROWN",
  "E1_COLOR_CURRENT",
  "E1_KEEP_EDITING",
  "E1_DISCARD",
  "E1_NEW_SHORT",
  "E1_IMPORT_TAGS",
  "E1_IMPORT_TAGS_HELP",
  "E1_IMPORT_ROWS",
  "E1_CREATE_PREPARED",
  "E1_RESOLVE_TAG",
  "E1_CREATE_ON_IMPORT",
  "E1_TAG_EFFECTS",
  "E1_EFFECT_CREATED",
  "E1_EFFECT_REUSED",
  "E3_TAGS_PENDING",
  "E3_TAGS_READY",
  "E3_CREATE_PREPARED",
  "E3_USE_EXISTING",
  "E3_NEW_MANAGE",
  "E3_NEW_MAP",
  "E3_BACK_PREVIEW",
  "E3_DETAIL",
  "E3_TAG_RESULTS",
  "E3_RESULT_CREATED",
  "E3_RESULT_REUSED",
  "E3_PENDING_REVIEW",
  "C1_TITLE",
  "C1_MORE_ACTIONS",
  "C1_MORE_FILTERS",
  "C1_CLEAR_SEARCH",
  "C1_CLEAR_FILTERS",
  "C1_NO_RESULTS_TITLE",
  "C1_SEARCH_EMPTY",
  "C1_FILTER_EMPTY",
  "C1_HIDDEN_RESULTS",
  "C1_HIDDEN_RESULTS_ONE",
  "C1_SELECTED_ACTIONS",
  "C1_SELECTED_ONE",
  "C1_SELECTED",
  "C1_COPIED_ONE",
  "C1_COPIED",
  "C1_EXPORTED_ONE",
  "C1_EXPORTED",
  "C1_SELECTION_COLUMN",
  "C1_ALL_INBOXES",
  "C1_SEARCH_INBOXES",
  "C1_CHOOSE_DATES",
  "C1_YESTERDAY",
  "C1_CHAT",
  "C1_IMPORT_TITLE",
  "C1_DROP_FILE",
  "C1_FILE_HELP",
  "C1_TEMPLATE_EXCEL",
  "C1_OPTIONAL",
  "C1_FIRST_REQUIRED",
  "C1_LAST_REQUIRED",
  "C1_PHONE_HELP",
  "C1_UNSAVED",
  "C1_DISCARD",
  "C1_KEEP_EDITING",
  "C1_UNDEFINED",
  "C1_TAG_COUNT",
  "C1_TAG_COUNT_ONE",
  "C1_ADD_TAG",
  "C1_ADD",
  "C1_TAGS_UPDATED",
  "C1_TAG_REMOVED",
  "C1_REMOVE_TAG",
  "C1_SORT_BY",
  "C1_SORT_RECENT",
  "C1_SORT_OLDEST",
  "C1_ORDER_LABEL",
  "C1_ORDER_RECENT",
  "C1_ORDER_OLDEST",
  "C1_ORDER_AZ",
  "C1_ORDER_ZA",
  "C1_ORDER_LOW",
  "C1_ORDER_HIGH",
  "C1_SORTED",
  "C1_LOADING_MORE",
  "C1_LOAD_MORE_FAILED",
  "C1_UNDO",
  "C1_DATA",
  "C1_MORE_DATA",
  "C1_UNCHANGED",
  "C1_OPEN_CHAT_SHORT",
  "C1_SESSIONS",
  "C1_ALWAYS_VISIBLE",
  "C1_DEFAULT_VIEW",
  "C1_DEFAULT_HELP",
  "C1_COUNT_ONE",
];
